import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const token = localStorage.getItem("Apptoken");

  // If logged in, redirect to dashboard (prevent access to login/forgot pages)
  return token ? <Navigate to="/dashboard/default" replace /> : <Outlet />;

};

export default PublicRoute;